// AppLayout — дизайн v8: шелл без сайдбара — разделы живут вкладками в
// хедере (HeaderNav внутри AppHeader). WsProvider живёт выше в App.tsx;
// сам layout не подписывается. API-health атом делает одну проверку на
// загрузку; статус — точка на колокольчике в AppHeader.
//
// Also hosts the What's New modal (12SA-0), auto-shown once per release: it
// opens when the stored "seen" version differs from RELEASE_VERSION and writes
// the version back on close. Storage failures are non-fatal (treated as seen).
// The account menu opens it too, through WhatsNewContext.

import { useCallback, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { primeServerRouteGasBoot } from '../../lib/serverRouteGas'
import { installSoundUnlock } from '../../lib/sound/engine'
import { MobileShell } from '../mobile/MobileShell'
import { WalletTrackerProvider } from '../notifications/WalletTrackerProvider'
import { WhatsNewProvider } from '../whatsnew/WhatsNewContext'
import { WhatsNewModal } from '../whatsnew/WhatsNewModal'
import { RELEASE_VERSION, SEEN_KEY } from '../whatsnew/releases'
import { AppHeader } from './AppHeader'
import styles from './AppLayout.module.css'

function seenCurrentRelease() {
  try {
    return localStorage.getItem(SEEN_KEY) === RELEASE_VERSION
  } catch {
    // storage blocked (private mode / disabled) — don't nag.
    return true
  }
}

export function AppLayout() {
  const [whatsNewOpen, setWhatsNewOpen] = useState(() => !seenCurrentRelease())
  // Мобильный шелл: те же роуты, CREW-хедер + SHEET-таббар (MobileShell).
  // Десктопная разметка страниц внутри не трогается — адаптация страниц
  // идёт отдельной линией (mobile/*).
  const isMobile = useMediaQuery('(max-width: 768px)')

  // Venue-level gas figures load while the user is still on the board, so
  // the first pair page ever opened renders gas on its first frame.
  useEffect(() => primeServerRouteGasBoot(), [])
  // Audio starts only after a user gesture: arm it on the first press or key.
  useEffect(() => installSoundUnlock(), [])

  const closeWhatsNew = () => {
    try {
      localStorage.setItem(SEEN_KEY, RELEASE_VERSION)
    } catch {
      // storage unavailable — the modal just re-shows next load.
    }
    setWhatsNewOpen(false)
  }
  // the account menu's door to it (WhatsNewContext); a stable function, so
  // nothing under the provider redraws for it
  const openWhatsNew = useCallback(() => setWhatsNewOpen(true), [])

  return (
    // Единый тост-стек — PixelToastProvider в App.tsx (2026-08-29: второй
    // провайдер ui/toast жил только ради ReferralsSection, переведён).
    <WalletTrackerProvider>
      <WhatsNewProvider open={openWhatsNew}>
        {isMobile ? (
          <MobileShell />
        ) : (
          <div className={styles.shell}>
            <div className={styles.main}>
              <AppHeader />
              <main className={styles.content}>
                <Outlet />
              </main>
            </div>
          </div>
        )}
      </WhatsNewProvider>
      <WhatsNewModal open={whatsNewOpen} onClose={closeWhatsNew} />
    </WalletTrackerProvider>
  )
}
